$(document).ready(function(){

    // $('.icon-rotate').click(function(){
    //     if($('.multi-collapse img').hasClass("js-rotate-icon")){
    //
    //     }else{
    //         $('.collapse-all').children('img').toggleClass("js-rotate-icon");
    //     }
    // });
    //

    // $(".collapse-all").click(function() {
    //     $('.multi-collapse').each(function(){
    //         var id = $(this).attr('id');
    //         if ($(this).hasClass('show')){
    //             $(this).collapse('hide');
    //         }
    //     });
    // });
});
